import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ResizeService {
  public screenWidth$ = new BehaviorSubject<number>(typeof window !== 'undefined' ? window.innerWidth : 0);
  public screenWidthChange$ = new BehaviorSubject<any>({
    isChanged: false,
    width: typeof window !== 'undefined' ? window.innerWidth : 0
  });

  constructor() { }


  initializeResizeEvent() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => this.updateResize());
    }
  }

  getWindowWidth() {
    return this.screenWidth$.value;
  }

  isDesktop() {
    return this.getWindowWidth() >= 1024;
  }

  getOrientation() {
    const portrait = window.matchMedia("(orientation: portrait)").matches; // |
    // const landscape = window.matchMedia("(orientation: landscape)").matches; // _
    return portrait ? 'portrait' : 'landscape';
  }


  isDesktopSpecialCase() {
    const width = this.getWindowWidth();
    const isPortrait = this.getOrientation() === 'portrait';
    const isLandscape = this.getOrientation() === 'landscape';
    return (width >= 768 && isLandscape) || (width >= 1024 && isPortrait);
  }

  isMobile() {
    return this.getWindowWidth() <= 768;
  }

  updateResize() {
    if (typeof window !== 'undefined') {
      const screenWidthTemp = window.innerWidth;
      if (this.screenWidth$.value != screenWidthTemp) {
        // special case happens when scrolling and hide the browser search bar..
        this.screenWidth$.next(screenWidthTemp);
        this.screenWidthChange$.next({
          isChanged: true,
          width: screenWidthTemp
        });
      }
    }
  }

}
